import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { css } from '@emotion/react';
import { gsap, ScrollTrigger } from 'gsap/all';
import { fullHeight, useHsHeader } from '../../util/hsHeader';
import FullScreenVideo from '../FullScreenVideo';
import { useDeviceSize } from '../../util/useDeviceSize';
import { useStory } from '../StoryContent';
import VideoMobile from '../VideoMobile';

gsap.registerPlugin(ScrollTrigger);

export default function VideoSlide45({ video }) {
  const [{ headerHeight }] = useHsHeader();
  const { toggleVideo } = useStory();
  const { isWideScreen } = useDeviceSize();

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const videoTriggerRef = useRef();

  useEffect(() => {
    if (!isWideScreen) {
      return undefined;
    }

    const tl = gsap
      .timeline()

      .to(videoTriggerRef.current, {
        duration: 0.2,
      })
      .add(() => {
        setIsVideoPlaying(v => !v);
      })
      .to(videoTriggerRef.current, {
        duration: 0.4,
      })
      .add(() => {
        setIsVideoPlaying(v => !v);
      })
      .to(videoTriggerRef.current, {
        duration: 0.2,
        opacity: 0,
      });

    const st = ScrollTrigger.create({
      animation: tl,
      trigger: videoTriggerRef.current,
      pin: true,
      pinSpacing: false,
      scrub: true,
      start: 'top top',
      end: `bottom 0`,
      anticipatePin: 1,
      onToggle: ({ isActive }) => {
        videoTriggerRef.current.style.pointerEvents = isActive
          ? 'auto'
          : 'none';
      },
    });

    return () => {
      tl.kill();
      st.kill();
    };
  }, [headerHeight, toggleVideo, video, isWideScreen]);

  return isWideScreen ? (
    <div
      css={css`
        ${fullHeight(4)};
        position: relative;
        z-index: 2;
        transform: translateY(-100vh);
        pointer-events: none;
      `}
      ref={videoTriggerRef}
    >
      <FullScreenVideo videoId={video.id} pause={!isVideoPlaying} />
    </div>
  ) : (
    <div
      css={css`
        padding: 150px 0 50px;
      `}
    >
      <VideoMobile videoId={video.id} />
    </div>
  );
}

VideoSlide45.propTypes = {
  video: PropTypes.shape({ id: PropTypes.number }),
};

VideoSlide45.defaultProps = {
  video: null,
};
